<template>
    <div class="container">
        <div class="main">
            <div class="img-wrap">
                <!-- <img src="@/assets/images/logo.png" /> -->
            </div>
            <div class="login-box">
                <div style="width: 100%">
                    <div class="title-box-login">
                        <span class="title">杰锐德管理后台</span>
                    </div>
                    <div class="edit-main">
                        <div class="edit-box">
                            <img class="icon" src="../assets/images/ic_login_account 2.png" />
                            <div class="boder-one" />
                            <input class="input" v-model="name" placeholder="请输入账号" autocomplete="new-password" />
                        </div>
                        <div class="edit-box">
                            <img class="icon" src="../assets/images/ic_login_password 2.png" />
                            <div class="boder-one" />
                            <input class="input" v-model="password" type="password" placeholder="请输入密码" autocomplete="new-password" />
                        </div>
                        <el-button class="login-btn" @click="event().onLogin()">登录 </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { login } from "@/api/auth";
import { detail } from "@/api/auth/user";
import Utils from "@/jslibs/utils";
import menuList from "@/configs/menus";

export default {
    data() {
        return {
            name: "admin",
            password: "admin",
        };
    },
    methods: {
        event() {
            return {
                onLogin: () => {
                    this.network().addlogin();
                },
            };
        },
        filterMenu(menu) {
            let newMenu = [];
            menuList.map((x) => {
                newMenu.push({
                    id: x.id,
                    name: x.name,
                    url: x.url,
                    children: [],
                });
            });
            menuList.map((x) => {
                x.children.map((y) => {
                    if (menu.indexOf(y.id) > -1) {
                        newMenu.find((m) => m.id === x.id).children.push(y);
                    }
                });
            });
            newMenu = newMenu.filter((x) => x.children.length > 0);
            return newMenu;
        },
        getKeys(menu) {
            let keys = [];
            const deep = (m) => {
                m.forEach((x) => {
                    keys.push(x.id);
                    if (x.children) {
                        deep(x.children);
                    }
                });
            };
            deep(menu);
            return keys;
        },
        network() {
            return {
                addlogin: async () => {
                    const { result, error, code } = await login({
                        account: this.name,
                        password: this.password,
                    });
                    if (code === 200) {
                        this.$message.success("登录成功");
                        Utils.setCookie("authorization", result.token);
                        this.$store.commit("setUserInfo", result);
                        if (result.account === "admin") {
                            this.$store.commit("setMenu", menuList);
                            this.$store.commit("setKeys", this.getKeys(menuList));
                            this.$router.push("/");
                        } else {
                            const keys = JSON.parse(result.group.desc).keys;
                            const menu = this.filterMenu(keys);
                            this.$store.commit("setMenu", menu);
                            this.$store.commit("setKeys", keys.split(","));
                            if (menu.length) {
                                setTimeout(() => {
                                    this.$router.push(this.$store.state.menuList[0].children[0].url);
                                }, 1000);
                            } else {
                                this.$message.warning("您账号绑定的角色被禁用或角色未绑定任何菜单，请联系管理员处理");
                            }
                        }
                    } else {
                        this.$message.error(error.message);
                    }
                },
            };
        },
    },
};
</script>

<style scoped lang="less">
.container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;

    .main {
        flex: 1;
        background: #fff;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0 5%;

        .img-wrap {
            width: 30%;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .login-box {
            display: flex;
            width: 30%;
            height: 360px;
            padding: 0 15px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.09);

            .title-box-login {
                width: 100%;
                margin-top: 53px;

                span.title {
                    margin: 0 21px;
                    font-size: 20px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: rgba(51, 51, 51, 1);
                    line-height: 28px;
                }
            }

            .edit-main {
                padding: 18px 17px 28px;

                .edit-box {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 45px;
                    margin-bottom: 30px;
                    padding: 0 12px;
                    border-radius: 3px;
                    border: 1px solid rgba(32, 53, 128, 0.16);

                    img.icon {
                        width: 17px;
                        margin-right: 14px;
                    }

                    div.boder-one {
                        width: 0px;
                        height: 24px;
                        border-left: 1px solid rgba(216, 221, 233, 1);
                    }

                    input.input {
                        padding: 0 14px;
                        flex: 1;
                        outline: none;
                        border: none;
                        font-size: 12px;
                    }
                }

                .login-btn {
                    width: 100%;
                    height: 45px;
                    background-color: #005eff;
                    border-radius: 3px;
                    color: #ffffff;
                }
            }
        }
    }
}

@media (max-width: 1280px) {
    .main {
        flex-direction: column;
        justify-content: center !important;

        .img-wrap {
            width: 45% !important;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .login-box {
            width: 50% !important;
            margin-top: 20px;
        }
    }
}

@media (max-width: 850px) {
    .main {
        flex-direction: column;
        justify-content: center !important;

        .img-wrap {
            width: 60% !important;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .login-box {
            width: 90% !important;
            margin-top: 20px;
        }
    }
}

:deep(input:-internal-autofill-selected) {
    background-color: none !important;
}
</style>
